import React, {useEffect, useState} from 'react';
import PropTypes                    from 'prop-types';
import FeatureFeedbackPanel         from '../FeatureFeedback/components/FeatureFeedbackPanel.js';
import FeatureFeedbackPanelResult   from '../FeatureFeedback/components/FeatureFeedbackPanelResult.js';
import Flux                         from '../../flux/Flux.js';

const FeatureFeedbackAsPanel = ({featureId, title, theme, isCollapsable}) => {
    const [featureFeedback, setFeatureFeedback] = useState(null);
    const [isFeedbackSent, setIsFeedbackSent]   = useState(false);

    // initial render
    useEffect(() => {
        const initFeatureFeedback = {id: featureId, title, theme};

        // if not already answered
        if (!Flux.Guest.getActiveFeatureIdsWithFeedback().includes(initFeatureFeedback?.id)) {
            setFeatureFeedback(initFeatureFeedback);
        }

        const onFeedbackSent = () => {
            setIsFeedbackSent(true);
        };
        Flux.Guest.addFeatureFeedbackSentListener(onFeedbackSent);

        return () => {
            Flux.Guest.removeFeatureFeedbackSentListener(onFeedbackSent);
        };
    }, []);


    const onTogglePopup = (rating) => {
        Flux.Guest.setFeatureFeedback(featureFeedback.id, rating);
    };

    if (!Flux.Guest.isLoggedIn() || !featureFeedback) {
        return null;
    }

    return (
            isFeedbackSent ? <FeatureFeedbackPanelResult /> :
                    <FeatureFeedbackPanel
                            isDark={featureFeedback?.theme === 'dark'}
                            title={featureFeedback?.title}
                            onTogglePopup={onTogglePopup} 
                            isCollapsable={isCollapsable}    
                    />
    );
};

FeatureFeedbackAsPanel.propTypes = {
    featureId:     PropTypes.number,
    title:         PropTypes.string,
    theme:         PropTypes.string,
    isCollapsable: PropTypes.bool,
};

export default FeatureFeedbackAsPanel;

